import angular from 'angular';
import debounce from 'debounce';
import template from './pills.html';
import './pills.scss';

export class PillsController {
  constructor($document, $scope, $timeout, appUtils) {
    'ngInject';

    [this.$document] = Array.from($document);
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.appUtils = appUtils;
    this.remainingPills = 0;
    this._selectors = {
      pills: '',
      container: '',
    };

    this._hasElements = false;
    this._elements = {
      pills: null,
      container: null,
    };
    this._lastItemsLength = -1;

    this._stopListening = () => {};
    const debounceTime = 300;
    this._listener = debounce(this._listener, debounceTime);
    this._listener = this._listener.bind(this);
  }
  $onInit() {
    this.canToggle = angular.isUndefined(this.canToggle) ? true : this.canToggle;

    this._selectors.container = `[data-pills-list="${this.id}"]`;
    this._selectors.pills = `${this._selectors.container} [data-pills-pill]`;
    this._stopListening = this.appUtils.attachWindowEvents('resize', this._listener);
    this._listener();
  }
  $onDestroy() {
    this._stopListening();
  }
  $doCheck() {
    if (this._lastItemsLength === -1) {
      this._lastItemsLength = this.items.length;
    } else if (this._lastItemsLength !== this.items.length) {
      this._lastItemsLength = this.items.length;
      this._hasElements = false;
      this._listener();
    }
  }
  $onChanges({ showAll }) {
    if (
      showAll &&
      showAll.previousValue === true &&
      showAll.currentValue === false
    ) {
      this.$timeout(() => {
        this._getElements().container.scrollTop = 0;
      });
    }
  }
  remove(pill) {
    this.onRemove({ pill });
  }
  toggle() {
    this.onToggle();
  }
  _listener() {
    const { pills } = this._getElements();
    const total = pills.length;
    let newRemainingPills = 0;
    const minRequiredPills = 2;
    if (total >= minRequiredPills) {
      for (let i = 0; i < total; i++) {
        if (i && (pills[i].offsetLeft <= pills[i - 1].offsetLeft)) {
          newRemainingPills = total - i;
          break;
        }
      }
    }

    if (newRemainingPills !== this.remainingPills) {
      this.$timeout(() => {
        this.remainingPills = newRemainingPills;
      });
    }
  }
  _getElements() {
    if (!this._hasElements) {
      this._elements.container = this.$document.querySelector(this._selectors.container);
      this._elements.pills = [...this.$document.querySelectorAll(this._selectors.pills)];
      this._hasElements = true;
    }

    return this._elements;
  }
}

export default {
  controller: PillsController,
  template,
  bindings: {
    id: '@',
    items: '<',
    itemsLabelProperty: '@',
    itemsIdProperty: '@',
    showAll: '<',
    canRemove: '<',
    canRemoveAll: '<',
    canToggle: '<',
    onToggle: '&',
    onRemove: '&',
  },
};
